import React from 'react';
import { ArrowDownUp, Filter as FilterIcon } from 'lucide-react';

const SortBar = ({ count, sortValue, sortOptions, onSortChange, onOpenFilters }) => (
  <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-3 flex items-center justify-between gap-3 flex-wrap">
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={onOpenFilters}
        data-testid="mobile-filters-btn"
        className="lg:hidden inline-flex items-center gap-1.5 text-sm font-semibold text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-700 rounded-md px-3 py-1.5 hover:border-red-300"
      >
        <FilterIcon className="h-4 w-4" />
        Filters
      </button>
      <p className="text-sm text-gray-700 dark:text-gray-300">
        Showing <span className="font-bold text-gray-900 dark:text-white">{count}</span> result{count === 1 ? '' : 's'}
      </p>
    </div>
    <div className="flex items-center gap-2">
      <ArrowDownUp className="h-4 w-4 text-gray-500 dark:text-gray-400" />
      <select
        value={sortValue}
        onChange={(e) => onSortChange(e.target.value)}
        data-testid="sort-select"
        className="border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
      >
        {sortOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  </div>
);

export default SortBar;
